import { COMPRESSION_PRESETS } from '@/config/compressionPresets'
import {
    useGetUserAvatarPresignUrl,
    useGetUserCoverPresignUrl,
    useGetCollectionCoverPresignUrl,
    useGetLookCoverPresignUrl,
    useGetProductImagePresignUrl,
    useGetFeedbackAttachmentPresignUrl,
    useGetTryOnPhotoPresignUrl,
} from '@/hooks/api/useUploads'
import { ImageUploadType, UploadTypeConfig } from '@wtf/shared'

export const UPLOAD_TYPE_CONFIGS: Record<ImageUploadType, UploadTypeConfig> = {
    [ImageUploadType.AVATAR]: {
        compressionPreset: COMPRESSION_PRESETS.AVATAR,
        presignHook: useGetUserAvatarPresignUrl,
        cropConfig: {
            aspectRatio: 1,
            shape: 'round',
            required: true,
            title: 'Crop Profile Picture',
        },
        defaultFileName: 'avatar.jpg',
    },

    [ImageUploadType.USER_COVER]: {
        compressionPreset: COMPRESSION_PRESETS.USER_COVER,
        presignHook: useGetUserCoverPresignUrl,
        cropConfig: {
            aspectRatio: 16 / 9,
            shape: 'rect',
            required: true,
            title: 'Crop Cover Photo',
        },
        defaultFileName: 'cover.jpg',
    },

    [ImageUploadType.COLLECTION_COVER]: {
        compressionPreset: COMPRESSION_PRESETS.COLLECTION_COVER,
        presignHook: useGetCollectionCoverPresignUrl,
        cropConfig: {
            aspectRatio: 4 / 3,
            shape: 'rect',
            required: true,
            title: 'Crop Collection Cover',
        },
        defaultFileName: 'collection-cover.jpg',
    },

    [ImageUploadType.LOOK_COVER]: {
        compressionPreset: COMPRESSION_PRESETS.LOOK_COVER,
        presignHook: useGetLookCoverPresignUrl,
        cropConfig: {
            aspectRatio: 3 / 4,
            shape: 'rect',
            required: true,
            title: 'Crop Look Cover',
        },
        defaultFileName: 'look-cover.jpg',
    },

    [ImageUploadType.PRODUCT_IMAGE]: {
        compressionPreset: COMPRESSION_PRESETS.PRODUCT,
        presignHook: useGetProductImagePresignUrl,
        cropConfig: {
            aspectRatio: 1,
            shape: 'rect',
            required: false,
            title: 'Crop Product Image',
        },
        defaultFileName: 'product-image.jpg',
    },

    [ImageUploadType.FEEDBACK_IMAGE]: {
        compressionPreset: COMPRESSION_PRESETS.PRODUCT, // Use product preset for feedback images
        presignHook: useGetFeedbackAttachmentPresignUrl,
        cropConfig: {
            aspectRatio: 16 / 9,
            shape: 'rect',
            required: false,
            title: 'Crop Feedback Image',
        },
        defaultFileName: 'feedback-attachment.jpg',
    },

    [ImageUploadType.TRY_ON_PHOTO]: {
        compressionPreset: COMPRESSION_PRESETS.PRODUCT, // High quality for try-on photos
        presignHook: useGetTryOnPhotoPresignUrl,
        cropConfig: {
            aspectRatio: 3 / 4, // Portrait aspect ratio for full body shots
            shape: 'rect',
            required: true,
            autoCrop: true, // Automatically center-crop to 3:4 without user interaction
            title: 'Crop Try-On Photo',
        },
        defaultFileName: 'try-on-photo.jpg',
    },
}
